import { format } from "date-fns";
import { AlertTriangle } from "lucide-react";

import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { getSessionOrganisation } from "@/features/organisations/utils/get-session-organisation";
import { useVidyoStore } from "@/features/vidyo-call/utils/vidyo-store";

export function RoomSystemConflicts() {
  const conflicts =
    useVidyoStore((s) => s.moderationDrawer.conflictingSessions) || [];

  if (conflicts.length === 0) return null;

  return (
    <Alert className="mt-4 border-border p-2">
      <div className="border-l-2 border-warning p-2">
        <AlertTitle className="flex items-center text-sm text-warning">
          <AlertTriangle className="mr-2 h-4 w-4" />
          Room System Conflicts
        </AlertTitle>
        <AlertDescription>
          {conflicts.map((session) => {
            const sessionDuration = `${format(
              session.start,
              "HH:mm",
            )} - ${format(session.end, "HH:mm")}`;

            return (
              <p key={session.id} className="mt-4 text-sm leading-none">
                <span className="block font-normal leading-none">
                  {getSessionOrganisation(session.invitedOrganisations)?.name}
                </span>

                <span key={session.id} className="leading-none">
                  <span className="font-medium">{session.name}</span>{" "}
                  {sessionDuration}
                </span>
              </p>
            );
          })}
        </AlertDescription>
      </div>
    </Alert>
  );
}
